<template>
  <iframe id="frame" frameborder="0"></iframe>
</template>
<script>
export default {
  name: 'Live',
  methods: {},
  mounted() {
    this.$nextTick(async () => {
      const { course_id, period_id, type, class_group_id, arrange_id, meeting_id } =
        this.$route.query;

      let liveData = await this.$http.post(
        '/api/assistants/assistantEnterRoom',
        {
          course_basis_id: course_id,
          chapter_id: period_id,
          type: type,
          class_group_id: class_group_id,
          arrange_id: arrange_id,
          meeting_id: meeting_id,
        },
        {
          onError: () => {
            // this.$router.push({ name: "Home" });
          },
        },
      );
      let frame = document.getElementById('frame');
      frame.allow =
        'microphone *;camera *;midi *;encrypted-media *;autoplay *;fullscreen *;display-capture *;';
      document.getElementById('frame').src = liveData.web_url;
    });
  },
};
</script>
<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 100vh;
  display: block;
}
</style>
